export const BOTTOM_SHEET_HANDLE_HEIGHT = 20;
export const BOTTOM_SHEET_SAFE_AREA_HEIGHT = 32;
// CSS constant
export const BOTTOM_SHEET_CONTENT_DEFAULT_MAX_HEIGHT = `
  calc(100vh - ${BOTTOM_SHEET_SAFE_AREA_HEIGHT}px - ${BOTTOM_SHEET_HANDLE_HEIGHT}px)
`;
